import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import Flex from "components/layout/Flex";
import Text from "components/layout/Text";
import { HelpCenter } from "constants/help-center";
import { trackEngagement } from "helpers/analytics";
import { IDeviceListItem } from "interfaces/entities/devices";
import { getItem } from "services/local-storage";
import { AgentActions } from "store/entities/agents";
import { getCurrentAgentId } from "store/features/session";
import { withVar } from "themes/helpers";

import { buttonContainerStyles, mobileBarStyles } from "./styles";

interface IProps {
  deviceList: IDeviceListItem[];
}

const CheckBrowserNotifications: React.FC<IProps> = ({ deviceList }) => {
  const dispatch = useDispatch();
  const agentId = useSelector(getCurrentAgentId);
  const deviceId = getItem(`agent-id:${agentId}`);
  const testButtonDisplayed = deviceList.length !== 0 && deviceId;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleTestPush = () => {
    dispatch(AgentActions.sendPushTest({ agentId: "me", deviceId }));
    trackEngagement("Browser notifications: Test push notification button clicked");
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleHelpCenterClick = () => {
    trackEngagement("Browser notifications: Troubleshooting clicked");
  };

  return (
    <Flex
      justifyContent="space-between"
      marginV="20px"
      alignItems="center"
      padding="12px 16px"
      borderRadius="4px"
      bg={`var(${DesignToken.SurfaceTertiaryDefault})`}
      css={mobileBarStyles}
    >
      <Flex alignItems="center">
        <Icon
          name={IconsEnum.Notifications}
          fill={withVar(DesignToken.ContentBasicPrimary)}
          height="20px"
          width="20px"
        />
        <Text marginLeft="8px">Test your browser notifications.</Text>
      </Flex>
      <Flex gap="16px" css={buttonContainerStyles}>
        {testButtonDisplayed && (
          <Button kind="plain" onClick={handleTestPush}>
            Test now
          </Button>
        )}
        <Button
          kind="text"
          onClick={handleHelpCenterClick}
          href={`${HelpCenter.ENABLE_BROWSER_NOTIFICATIONS}#test-your-browser-notifications`}
          target="_blank"
        >
          Not working?
        </Button>
      </Flex>
    </Flex>
  );
};

export default CheckBrowserNotifications;
